import { InsertionOrder } from "../types/internalCampaignTypes";

export const resolveOrderLabel = (order: InsertionOrder, fallback: string) => {
  if (!order) {
    return fallback;
  }
  if (order.displayName) {
    return order.displayName;
  }
  if ("name" in order && order.name) {
    return order.name;
  }
  return fallback;
};

export const resolveOrderUniqueId = (order: InsertionOrder | undefined) => {
  if (!order) {
    return undefined;
  }
  if (order.insertionOrderId) {
    return order.insertionOrderId;
  }
  if ("id" in order) {
    return order.id ?? undefined;
  }
  return undefined;
};

export const resolveOrderMargin = (order: InsertionOrder | undefined) => {
  if (!order) {
    return undefined;
  }
  if ("margin" in order && typeof order.margin === "number") {
    return order.margin;
  }
  if (
    "margin" in order &&
    typeof order.margin === "string" &&
    !Number.isNaN(Number(order.margin))
  ) {
    return Number(order.margin);
  }
  return undefined;
};

export const resolveSourceCampaignId = (order: InsertionOrder | undefined) => {
  if (!order) {
    return undefined;
  }
  if ("sourceCampaignId" in order && order.sourceCampaignId) {
    return order.sourceCampaignId;
  }
  if (order.campaignId) {
    return order.campaignId;
  }
  return undefined;
};

export const resolveOrderKey = (
  order: InsertionOrder | undefined,
  fallbackIndex: number
): string => {
  if (!order) {
    return `order-${fallbackIndex}`;
  }

  const candidates: (string | undefined)[] = [];

  if (typeof order.insertionOrderId === "string") {
    candidates.push(order.insertionOrderId);
  }

  if ("id" in order) {
    const rawId = (order as { id?: unknown }).id;
    if (typeof rawId === "string") {
      candidates.push(rawId);
    }
  }

  const resolved = candidates.find(
    (candidate) => candidate && candidate.trim().length > 0
  );

  return resolved ?? `order-${fallbackIndex}`;
};
